import { SvgIcon } from '@mui/material';
import type { Components } from '@mui/material/styles';
import CheckboxActiveIcon from '@/ui/kit/icons/checkbox-active.svg';
import CheckboxInactiveIcon from '@/ui/kit/icons/checkbox-inactive.svg';
export const MuiCheckbox: Components['MuiCheckbox'] = {
  defaultProps: {
    icon: <SvgIcon fill="red" component={CheckboxInactiveIcon} />,
    checkedIcon: <SvgIcon fill="red" component={CheckboxActiveIcon} />,
    color: 'primary'
  },
  styleOverrides: {
    root: {
      padding: 8
    }
  }
};